'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const PaperClipIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="PaperClipIcon">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.44361 8.95107L9.49878 3.8959C9.60838 3.78181 9.73964 3.69073 9.88488 3.62799C10.0301 3.56525 10.1864 3.53212 10.3446 3.53053C10.5028 3.52894 10.6597 3.55893 10.8062 3.61874C10.9527 3.67854 11.0857 3.76697 11.1976 3.87884C11.3095 3.99071 11.3979 4.12377 11.4577 4.27024C11.5175 4.4167 11.5475 4.57363 11.5459 4.73183C11.5443 4.89003 11.5112 5.04632 11.4484 5.19155C11.3857 5.33679 11.2946 5.46805 11.1805 5.57765L4.35203 12.4277C3.90585 12.8738 3.30072 13.1244 2.66978 13.1244C2.03884 13.1243 1.43376 12.8736 0.987655 12.4274C0.54155 11.9813 0.290961 11.3761 0.291016 10.7452C0.29107 10.1143 0.541764 9.50917 0.987946 9.06307L8.12445 1.92773C8.73772 1.31439 9.56952 0.969781 10.4369 0.969727C11.3042 0.969672 12.1361 1.31417 12.7494 1.92744C13.3628 2.54071 13.7074 3.37251 13.7074 4.23986C13.7075 5.10721 13.363 5.93905 12.7497 6.5524L7.69511 11.6081"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeWidth="0.583333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

PaperClipIcon.propTypes = {
  sx: PropTypes.object
}
